module.exports = __webpack_public_path__ + "static/media/Thermocycler.6eb899b8.svg";